module.exports = __webpack_public_path__ + "img/option-02.28fd9749.svg";